import { render } from "./ExportarModal.vue?vue&type=template&id=5368cdf4"
import script from "./ExportarModal.vue?vue&type=script&lang=js"
export * from "./ExportarModal.vue?vue&type=script&lang=js"

import "./ExportarModal.vue?vue&type=style&index=0&id=5368cdf4&lang=css"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Projetos\\WIP\\Reorganiza\\Leadcenter\\Dashboard\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__